import * as React from 'react';
import './ApplyCreditMadePayment.scss';
import InterfaceIcon from '../../../../../assets/interface';
import PrintIcon from '../../../../../assets/print';
import exportIcon from '../../../../../assets/export';
import xlsxIcon from '../../../../../assets/xlsxIcon';
import pdfIcon from '../../../../../assets/pdfIcon';
import downarrowIcon from '../../../../../assets/downArrow';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import {
  IFiltersInvoice,
  IInvoiceCreditPayment
} from 'src/services/invoice/InvoiceService';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';
import i18n from 'src/translation/i18n';

interface ISummaryState {
  showLoader: boolean;
}
class ApplyCreditOriginal extends React.Component<any, ISummaryState> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false
    };
  }
  public Backinvoices = () => {
    this.props.history.push('/invoices');
  };
  public doExport = (type: string) => {
    const debitDataList: any[] = this.props.location.state.debitDataList
      ? this.props.location.state.debitDataList
      : [];
    const creditDataList: any[] = this.props.location.state.creditDataList
      ? this.props.location.state.creditDataList
      : [];
    const paymentDetails: any[] = this.props.location.state.paymentDetails
      ? this.props.location.state.paymentDetails
      : [];
    // if (
    //   this.props.location.state.page &&
    //   this.props.location.state.page === 'manual'
    // ) {
    //   debitDataList.forEach(x => {
    //     const selected = paymentDetails.filter(
    //       a => a.invoice.invoiceNumber === x.invoiceNumber
    //     )[0];
    //     if(selected.totalAmount){
    //       x.totalAmount = selected.totalAmount
    //       x.paymentAmount = selected.paymentAmount
    //       x.remainingAmount = (
    //         selected.invoice.remainingAmount / 1 -
    //         selected.paymentAmount / 1
    //       ).toFixed(2);
    //     }

    //   });
    //   creditDataList.forEach(x => {
    //     const selected = paymentDetails.filter(
    //       a => a.invoice.invoiceNumber === x.invoiceNumber
    //     )[0];
    //     if(selected.totalAmount){
    //       x.totalAmount = selected.totalAmount;
    //       x.paymentAmount = selected.paymentAmount;
    //       x.remainingAmount = (
    //         selected.invoice.remainingAmount / 1 -
    //         selected.paymentAmount / 1
    //       ).toFixed(2);
    //     }
    //   });
    // }
    if (type === 'pdf') {
      this.setState({ showLoader: true });
      InvoiceService.exportSelectedInvoicesSummary(
        type,
        this.props.location.state.paymentId,
        0,
        0,
        this.props.location.state.page
      )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `SelectedInvoices_Summary.pdf`);
        })
        .catch(error => {
          console.log(error);
          this.setState({ showLoader: false });
        });
    } else if (type === 'xlsx') {
      this.setState({ showLoader: true });
      InvoiceService.exportSelectedInvoicesSummary(
        type,
        this.props.location.state.paymentId,
        0,
        0,
        this.props.location.state.page
      )
        .then((response: any) => {
          this.setState({ showLoader: false });
          downloadFile(response.data, `SelectedInvoices_Summary.xlsx`);
        })
        .catch(error => {
          console.log(error);
          this.setState({ showLoader: false });
        });
    }
  };
  public printPdf = () => {
    this.doExport('pdf');
  };
  public printExcel = () => {
    this.doExport('xlsx');
  };

  public getInvoiceCount = () => {
    if (
      this.props.location.state &&
      this.props.location.state.orderlist &&
      this.props.location.state.orderlist.length > 0 &&
      this.props.location.state.totalDebitInvoice
    ) {
      return this.props.location.state.totalDebitInvoice;
    } else if (
      this.props.location.state &&
      this.props.location.state.orderlist &&
      this.props.location.state.orderlist.length > 0
    ) {
      return this.props.location.state.orderlist.length;
    }
    return 0;
  };

  public getInvoiceCountManual = () => {
    let count = 0;
    const paymentDetails: any[] = this.props.location.state.paymentDetails;
    if (this.props.location.state && paymentDetails) {
      paymentDetails.forEach(value => {
        if (value.isDebitInvoice) {
          count = count + 1;
        }
      });
    }
    return count;
  };

  public render() {
    console.log('props', this.props);
    return (
      <div className="section-loader">
        {this.state.showLoader ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
          ''
        )}
        <div className="apply-credit">
          <img className="interface-icon" src={InterfaceIcon} />
          <div className="success-msg">
            {i18n.t('invoices.successfullyAppliedTheCredit')}
          </div>
          <button className="back-btn" onClick={this.Backinvoices}>
            {i18n.t('invoices.backToOpenInvoices')}
          </button>
          <div className="transaction-details">
            <div className="details-label">
              {i18n.t('invoices.transactionDetails')}
            </div>
            <div className="d-flex amount-details">
              <span className="credit-used-amount">
                <b>
                  {`${
                    this.props.location.state
                      ? this.props.location.state &&
                        this.props.location.state.page === 'manual'
                        ? this.props.location.state.creditUsed <=
                          Math.abs(this.props.location.state.totalAmount)
                          ? currencyFormatter(
                              this.props.location.state.creditUsed
                            )
                          : currencyFormatter(
                              Math.abs(this.props.location.state.totalAmount)
                            )
                        : currencyFormatter(
                            this.props.location.state.creditUsed
                          )
                      : currencyFormatter(0)
                  }`}{' '}
                </b>
                {i18n.t('invoices.ofCreditUsed')}
              </span>
              {/* <span className="line-gap">|</span>
            <span className="credit-used-amount">
              <b>$2,000.00</b> paid using E-check
            </span> */}
              <span className="line-gap">|</span>
              <span className="credit-used-amount">
                {' '}
                <b>
                  {this.props.location.state &&
                  this.props.location.state.page === 'manual'
                    ? this.getInvoiceCountManual()
                    : this.getInvoiceCount()}
                </b>{' '}
                {i18n.t('invoices.invoicesPaid')}{' '}
              </span>
            </div>
            {this.props.location.state &&
              this.props.location.state.paymentId &&
              this.props.location.state.paymentId.length > 0 && (
                <div>
                  <div className="d-flex justify-content-center">
                    <div className="export-text">
                      {i18n.t('invoices.Export')}
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="print" onClick={this.printExcel}>
                      <img className="image-icon xlsx-icon" src={xlsxIcon} />
                    </div>
                    <div className="export" onClick={this.printPdf}>
                      <img className="image-icon" src={pdfIcon} />
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default ApplyCreditOriginal;
